import Patients from '~/pages/patients';
import PatientsAdd from '~/pages/patients/add';
import PatientsFaceSheet from '~/pages/patients/face-sheet';
import PatientsDemographics from '~/pages/patients/demographics';
import PatientsBadge from '~/pages/patients/badge';
import PatientsDocsCollection from '~/pages/patients/docs/collection';
import PatientsDocsDetails from '~/pages/patients/docs/details';

import IdentityPrimaryContacts from '~/pages/patients/identity/primary-contacts';
import IdentityChildrensServices from '~/pages/patients/identity/childrens-services';
import IdentityCompletedVisits from '~/pages/patients/identity/completed-visits';
import IdentityReports from '~/pages/patients/identity/reports';
import IdentityHealthInformation from '~/pages/patients/identity/health-information';
import IdentityReferralsAndAppointments from '~/pages/patients/identity/referrals-appointments';

import AddRedirect from '~/pages/patients/add-redirect';
import DetailsRedirect from '~/pages/patients/details-redirect';

import NotesCollection from '~/pages/patients/notes/collection';
import NotesDetails from '~/pages/patients/notes/details';
import NotesAdd from '~/pages/patients/notes/add';

import DiagnosesCollection from '~/pages/patients/diagnoses/collection';
import DiagnosesDetails from '~/pages/patients/diagnoses/details';
import DiagnosesAdd from '~/pages/patients/diagnoses/add';

import RemindersCollection from '~/pages/patients/reminders/collection';
import RemindersAdd from '~/pages/patients/reminders/add';

import MedicalEventsCollection from '~/pages/patients/medical-events/collection';
import MedicalEventsDetails from '~/pages/patients/medical-events/details';
import MedicalEventsCitDetails from '~/pages/patients/medical-events/cit-details';
import MedicalEventsAdd from '~/pages/patients/medical-events/add';

import MedicalEventRedirect from '~/pages/patients/medical-events/redirect';

import Login from '~/pages/login';
import Chat from '~/pages/chat';
import Home from '~/pages/home';
import QueuesIndex from '~/pages/home/queues';
import HomeCalendar from '~/pages/home/coordinator/calendar';

import HWC from '~/pages/hwc';
import HwcDetails from '~/pages/hwc/details';

import B2W from '~/pages/b2w';
import AllRemindersIndex from '~/pages/home/reminders/collection';
import ProgramDashboard from '~/pages/program-dashboard';

import EngagementsOptOut from '~/pages/engagements/opt-out';

import AdmissionsCollection from '~/pages/patients/admissions/collection';
import AdmissionsDetails from '~/pages/patients/admissions/details';

import Ext from '~/pages/ext';
import Cit from '~/pages/cit';
import CitSubmission from '~/pages/cit/CITSubmission';
import CitRedirect from '~/pages/cit/redirect';

import Reports from '~/pages/reports';
import ConfiguredReports from '~/pages/reports/configured';
import CustomReports from '~/pages/reports/custom';

import PatientRedirect from '~/pages/patient/redirect';
import PatientsTeller from '~/pages/patients/teller';
import ResourceLibrary from '~/pages/resource-library/resource-library';

import { RouteTeller } from '@cordata/buffet';
import SupportCard from '~/components/SupportForm';

import PatientsAudit from '~/pages/patients/audit';

import PatientsOutboundReferralDetails from '~/pages/patients/outbound-referrals/details';
import PatientsOutboundReferralCollection from '~/pages/patients/outbound-referrals/collection';
import PatientsOutboundReferralAdd from '~/pages/patients/outbound-referrals/add';

import PatientsAllergiesDetails from '~/pages/patients/allergies/details';
import PatientsAllergiesCollection from '~/pages/patients/allergies/collection';

import PatientsCareTeamDetails from '~/pages/patients/care-team/details';
import PatientsCareGiversDetails from '~/pages/patients/care-givers/details';
import PatientsCareTeamCollection from '~/pages/patients/care-team/collection';

import PatientsResourceCollection from '~/pages/patients/resource/collection';

import PatientsMedicationsDetails from '~/pages/patients/medications/details';
import PatientsMedicationsCollection from '~/pages/patients/medications/collection';

import SessionTimeout from '~/pages/session-timeout';

const routes = [{
  path: '/home/queues/:queue_id',
  component: QueuesIndex,
}, {
  path: '/home',
  component: Home,
  label: 'Home',
  icon: 'home',
  main: true,
  private: true,
  routes: [{
    path: '/home/reminders',
    component: AllRemindersIndex,
    label: 'All Reminders',
  }, {
    path: '/home/calendar',
    component: HomeCalendar,
  }],
}, {
  path: '/patients/add',
  component: PatientsAdd,
  label: 'Patient Add',
  private: true,
}, {
  path: '/patient/:patientId',
  component: PatientRedirect,
  label: 'Patient Redirect',
  private: true,
}, {
  path: '/patients/:patient_id',
  component: PatientsTeller,
  routes: [{
    path: 'audit',
    component: PatientsAudit,
  }, {
    path: 'care-givers/:id',
    component: PatientsCareGiversDetails,
    currentWhen: 'care-team',
  }, {
    path: 'care-team/:id',
    component: PatientsCareTeamDetails,
  }, {
    path: 'care-team',
    component: PatientsCareTeamCollection,
  }, {
    path: 'outbound-referrals',
    component: RouteTeller,
    routes: [{
      path: '',
      component: PatientsOutboundReferralCollection,
      exact: true,
    }, {
      path: 'add',
      component: PatientsOutboundReferralAdd,
    }, {
      exact: true,
      path: ':outboundReferralId',
      component: PatientsOutboundReferralDetails,
    }],
  }, {
    path: 'allergies/:allergyId',
    component: PatientsAllergiesDetails,
  }, {
    path: 'allergies',
    component: PatientsAllergiesCollection,
  }, {
    path: 'resource',
    component: PatientsResourceCollection,
  }, {
    path: 'medications/:medicationId',
    component: PatientsMedicationsDetails,
  }, {
    path: 'medications',
    component: PatientsMedicationsCollection,
  }, {
    path: 'face-sheet',
    component: PatientsFaceSheet,
  }, {
    path: 'demographics',
    component: PatientsDemographics,
  }, {
    path: 'badge',
    component: PatientsBadge,
  }, {
    path: 'diagnoses',
    component: RouteTeller,
    routes: [{
      path: '',
      component: DiagnosesCollection,
      exact: true,
    }, {
      path: 'add',
      component: DiagnosesAdd,
    }, {
      path: 'new',
      component: AddRedirect,
    }, {
      path: ':diagnosis_id/details',
      component: DiagnosesDetails,
    }, {
      path: ':diagnosis_id/edit',
      component: DetailsRedirect,
    }],
  }, {
    path: 'docs/:docId',
    component: PatientsDocsDetails,
  }, {
    path: 'docs',
    component: PatientsDocsCollection,
  }, {
    path: 'notes',
    component: RouteTeller,
    routes: [{
      path: '',
      component: NotesCollection,
      exact: true,
    }, {
      path: 'add',
      component: NotesAdd,
    }, {
      path: ':note_id/details',
      component: NotesDetails,
    }],
  }, {
    path: 'admissions',
    component: RouteTeller,
    routes: [{
      path: '',
      component: AdmissionsCollection,
      exact: true,
    }, {
      exact: true,
      path: ':id',
      component: AdmissionsDetails,
    }],
  }, {
    private: true,
    path: 'reminders',
    component: RouteTeller,
    routes: [{
      path: '',
      component: RemindersCollection,
      exact: true,
    }, {
      path: 'add',
      component: RemindersAdd,
    }],
  }, {
    private: true,
    path: 'medical-events/:refMedicalEventName',
    component: RouteTeller,
    routes: [{
      path: '',
      component: MedicalEventsCollection,
      exact: true,
    }, {
      path: 'add',
      component: MedicalEventsAdd,
    }, {
      path: ':medical_event_id/details',
      component: MedicalEventsDetails,
    }, {
      path: ':medical_event_id/cit-details',
      component: MedicalEventsCitDetails,
    }],
  }, {
    path: 'medical-events',
    component: MedicalEventRedirect,
  }, {
    private: true,
    path: 'primary-contacts',
    component: IdentityPrimaryContacts,
  }, {
    private: true,
    path: 'childrens-services',
    component: IdentityChildrensServices,
    caseRestricted: true,
  }, {
    private: true,
    path: 'completed-visits',
    component: IdentityCompletedVisits,
    caseRestricted: true,
  }, {
    private: true,
    path: 'reports',
    component: IdentityReports,
    caseRestricted: true,
  }, {
    // Not case-restricted: per the product doc, Health Information stays visible under a
    // plain case restriction. It's only hidden when legal status is missing entirely.
    private: true,
    path: 'health-information',
    component: IdentityHealthInformation,
    legalStatusRestricted: true,
  }, {
    private: true,
    path: 'referrals-appointments',
    component: IdentityReferralsAndAppointments,
    caseRestricted: true,
  }],
}, {
  path: '/patients',
  component: Patients,
  icon: 'users',
  label: 'Clients',
  main: true,
  active: ['hasAppNavigator', 'hasAppIdentity'],
  private: true,
}, {
  path: '/resource-library',
  component: ResourceLibrary,
  icon: 'book',
  label: 'Resource Library',
  main: true,
  private: true,
}, {
  path: '/login',
  component: Login,
},
{
  path: '/support',
  component: SupportCard,
  exact: true,
},
{
  path: '/b2w',
  component: B2W,
  exact: true,
}, {
  path: '/hwc',
  component: HWC,
  exact: true,
}, {
  path: '/engagements/opt-out/:token',
  component: EngagementsOptOut,
  exact: true,
}, {
  path: '/program-dashboard',
  component: ProgramDashboard,
  icon: 'home',
  label: 'Program Dashboard',
  active: 'isDirector',
  private: true,
}, {
  path: '/ext/:externalActionInstance/:type',
  component: Ext,
  exact: true,
}, {
  path: '/ext/:externalActionInstance',
  component: Ext,
  exact: true,
}, {
  path: '/cit/:state',
  component: Cit,
  exact: true,
}, {
  path: '/cit-submission/:submissionId',
  component: CitSubmission,
  exact: true,
  private: true,
}, {
  path: '/cit',
  component: CitRedirect,
  exact: true,
}, {
  private: true,
  path: '/hwc/:id',
  component: HwcDetails,
  exact: true,
}, {
  path: '/reports',
  component: Reports,
  label: 'Reports',
  icon: 'chart-line',
  active: 'hasReports',
  main: true,
  private: true,
  routes: [{
    path: 'configured/:reportName',
    component: ConfiguredReports,
  }, {
    path: 'custom/:reportName',
    component: CustomReports,
  }],
}, {
  path: '/chat',
  component: Chat,
  label: 'Chat',
  icon: 'comments',
  active: 'chat',
  main: true,
  private: true,
}, {
  path: '/session-timeout',
  component: SessionTimeout,
}];

export default routes;
